import { createAsyncThunk } from "@reduxjs/toolkit";

import { GET_USER } from "../../consts/apis";

import api from "../../services/api";

export const fetchUserMetadata = createAsyncThunk(
  "ownUser/fetchUserMetadata",
  async () => {
    const {
      data: { user },
    } = await api.get(GET_USER());
    return { metadata: user };
  }
);
